import { useSmOrMdScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Loader } from "@circle-react-uikit/Loader";
import { usePlans } from "./PlansContext";
import { PlansDesktop } from "./PlansDesktop";
import { PlansMobile } from "./PlansMobile";

export const Plans = () => {
  const isMobile = useSmOrMdScreenMediaQuery();
  const { plans, isRenewLoading, isUpdatingSubscription, isListingPlans } =
    usePlans();

  if (isListingPlans) {
    return <Loader variant="fullscreen" />;
  }

  return (
    <>
      {(isRenewLoading || isUpdatingSubscription) && (
        <Loader variant="fullscreen" />
      )}

      {isMobile ? (
        <PlansMobile plans={plans} />
      ) : (
        <PlansDesktop plans={plans} />
      )}
    </>
  );
};
